import css from 'styled-jsx/css';

export default css`
  .moduloFeatureISR {
    padding-top: 60px;
    &_bgColor {
      &--grey {
        background-color: var(--color-movistar--grey1);
      }
    }
    .container {
      display: flex;
      flex-direction: column;
      gap: 1.5rem;
    }
    .featureISR {
      display: flex;
      justify-content: space-between;
      gap: 50px;
      .featureISR-img {
        width: 100%;
        > img {
          width: 100%;
        }
      }

      .featureISR-content {
        width: 100%;
        &_textAlign {
          &--center {
            display: flex;
            flex-direction: column;
            justify-content: center;
          }
        }
        .featureISR-title {
          padding-bottom: 1rem;
        }
        .featureISR-description {
          font-family: 'Regular';
          font-style: normal;
          font-weight: 400;
          font-size: 18px;
          line-height: 26px;
          color: #86888c;
        }
        :global(.iconLabel) {
          margin-bottom: 10px;
        }
        :global(.heading-gp--title04) {
          font-size: 1.6rem;
        }
        .container-button {
          width: 50%;
          margin-top: 20px;
        }
        .containerDownloads {
          padding-top: 1.5rem;
          display: flex;
          gap: 1rem;
        }
      }
    }
    .align-left {
      flex-direction: row-reverse;
    }
  }

  @media screen and (max-width: 830px) {
    .moduloFeatureISR .featureISR {
      flex-direction: column;
      :global(.alignImage) {
        margin: 0 auto;
      }
      .featureISR-content {
        .container-button {
          width: 100%;
        }
      }
    }
    .moduloFeatureISR .customStyle {
      flex-direction: column-reverse;
    }
  }
`;
